import React, { useRef } from "react";
import { Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const TopTrendingSection = () => {
  const swiperRef = useRef(null);

  // Static destinations
// Static destinations
const destinations = [
  {
    name: "Kathmandu",
    slug: "kathmandu",
    image: "/Images/tour/kathmandu.webp",
  },
  {
    name: "Pokhara",
    slug: "pokhara",
    image: "/Images/tour/Pokhara.jpg",
  },
  {
    name: "Manokamna",
    slug: "manokamna",
    image: "/Images/tour/Manokamna.jpeg",
  },
  {
    name: "Lumbini",
    slug: "lumbini",
    image: "/Images/tour/Lumbini.jpg",
  },
  {
    name: "Muktinath",
    slug: "muktinath",
    image: "/Images/tour/Muktinath.jpg",
  },
  {
    name: "Chitwan",
    slug: "chitwan",
    image: "/Images/tour/Chitwan.jpg",
  },
  {
    name: "Janakpur",
    slug: "janakpur",
    image: "/Images/tour/Janakpur.jpg",
  },
  {
    name: "Varanasi",
    slug: "varanasi",
    image: "/Images/tour/Varanasi.webp",
  },
  {
    name: "Ayodhya",
    slug: "ayodhya",
    image: "/Images/tour/Ayodhya.webp",
  },
  {
    name: "Kushinagar",
    slug: "kushinagar",
    image: "/Images/tour/Kushinagar.jpg",
  },
  {
    name: "Darjeeling",
    slug: "darjeeling",
    image: "/Images/tour/darjeeling.jpeg",
  },
  {
    name: "Sikkim",
    slug: "sikkim",
    image: "/Images/tour/Sikkim.jpg",
  },
];

  return (
    <div>
      <Container>
        <h2 className="custom_heading ft-700 mt-20 text-center">
          <span className="tourSection-text-b">Top </span> Spiritual & Pilgrimage <br/>
          Destinations for Muktinath Darshan
        </h2>

        <div className="text trending-tour-textbb text-center mb-4">
          Discover sacred temples, divine destinations, and peaceful pilgrimage
          journeys across Nepal and India for a blessed travel experience.
        </div>

        <Row className="jckpt_box_prnt" style={{ position: "relative" }}>
          <Swiper
            slidesPerView={6}
            breakpoints={{
              "@0.00": { slidesPerView: 2, spaceBetween: 10 },
              "@0.75": { slidesPerView: 3, spaceBetween: 20 },
              "@1.00": { slidesPerView: 4, spaceBetween: 40 },
              "@1.50": { slidesPerView: 5, spaceBetween: 10 },
            }}
            autoplay
            loop
            navigation={{
              nextEl: ".custom-next",
              prevEl: ".custom-prev",
            }}
            className="mySwiper"
            style={{ paddingBottom: "40px" }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {destinations.map((destination, index) => (
              <SwiperSlide key={index}>
                <Link
                  className="jckpt_box text-center tilt-card-box"
                  to={`/${destination.slug}`}
                >
                  <div className="img_box hoverEff">
                    <img
                      src={destination.image}
                      alt={destination.name}
                      loading="lazy"
                    />
                  </div>
                  <span className="f-20 mt-15 ft-600">
                    {destination.name}
                  </span>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Navigation Arrows */}
          <div
            className="custom-next"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <FaChevronRight />
          </div>
          <div
            className="custom-prev"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <FaChevronLeft />
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default TopTrendingSection;
